/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 11:07:10
 * @LastEditors: dong
 * @LastEditTime: 2026-02-26 10:22:58
 */
import store from "@/store";

export function getUyuDomain() {
  let uyuHost = '';
  uyuHost = store.state.hostReturnPath ? store.state.hostReturnPath : `${this.getHost()}#/login`;
  return uyuHost;
}
/**
 * 项目域名拼接
 */
export function getHost() {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  let domain = "";
  if (hostname.indexOf("localhost") > -1) { // 开发版
    domain = "http://localhost:4200/";
  } else {
    domain = (protocol ? protocol : 'https:') + "//fisheries.ucfarm.ai/";
  }
  return domain;
}
// 退出
export function doExit() {
  const path = store.state.hostReturnPath ? store.state.hostReturnPath : `${this.getHost()}#/login`;
  return ['ZHANYU', 'LIANTONG'].includes(store.state.hostLabel) ? path : `${this.getHost()}#/login`;
}
/**
 * @brief: 获取一级域名+后缀
 * @author: Scarlett Xiao
 * @Date: 2021-12-09 10:16:41
 */
export function getDomain() {
  let cookie_main = '';
  const isDev = window.location.hostname === 'localhost' ? true : false;
  if (isDev) {
    cookie_main = 'localhost';
  } else {
    cookie_main = 'ucfarm.ai';
  }
  return cookie_main;
}
// 获取iot跳转平台的url
export function getIOTPath() {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  let url = null;
  if (hostname == "localhost") {
    // 开发版
    url = "http://localhost:8080/";
  } else {
    url = (protocol ? protocol : "https:") + "//fisheries-iot.ucfarm.ai/";
  }
  return url;
}